import React from 'react';
import Row from './row';

export default function GenericTable({ title, rows, iconColor, headerAction }) {
  return (
    <div className="tw-w-full tw-mt-4">
      {title && rows?.length > 0 && (
        <div className="tw-font-semibold tw-mb-4 tw-pl-4 tw-flex tw-justify-between tw-items-center tw-pr-4">
          <span>{title}</span>
          {headerAction && <div className="tw-ml-4">{headerAction}</div>}
        </div>
      )}

      <div className="tw-rounded-md tw-bg-white tw-divide-solid tw-divide-x-0 tw-divide-y tw-divide-background tw-overflow-x-auto">
        {rows?.map((row, index) => (
          <Row
            key={`${row?.title}-${index}`}
            iconColor={iconColor}
            color={row?.color}
            title={row?.title}
            subtitle={row?.subtitle}
            icon={row?.icon}
            onClick={row?.onClick}
            buttonText={row?.buttonText}
            status={row?.status}
            statusText={row?.statusText}
            statusStyle={row?.statusStyle}
            fields={row?.fields}
            actions={row?.actions}
            titleWidthClass={row?.titleWidthClass}
          />
        ))}
      </div>
    </div>
  );
}
